import { consumePuzzelLogoutPending } from "app/PuzzelAuth/puzzelTokenStorage";
import { TrainLoader } from "app/TrainLoader";
import { signOut as cognitoSignOut } from "aws-amplify/auth";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { FC, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Puzzel's own logout redirect lands here; only now do we finish signing out of Vy/Entra,
// so the two full-page logout redirects run one after another instead of racing.
export const PuzzelLogoutContinue: FC = () => {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    // Reached without a logout we started (back button after re-login, bookmark, shared link) -
    // don't sign the user out.
    if (!consumePuzzelLogoutPending()) {
      void navigate("/", { replace: true });
      return;
    }

    cognitoSignOut({ global: true }).catch((error) => {
      log(
        LogLevel.error,
        "PuzzelLogoutContinue",
        "Failed to sign out of Vy after Puzzel logout",
        error,
      );
      // cognitoSignOut normally navigates away itself - without this fallback, a failure here
      // would leave the user stuck on this loading screen indefinitely.
      void navigate("/", { replace: true });
    });
  }, [navigate]);

  return <TrainLoader />;
};
